import { IconButton, Typography } from '@mui/material';
import { styled } from '@mui/system';

export const InsuranceInfoDiv = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  height: '40px',
  padding: '5px 5px 5px 22px',
  marginTop: '12px',
  backgroundColor: '#E6F3FA',
  transition: 'all 0.3s ease-in-out',
  [theme.breakpoints.down('md')]: {
    height: '60px',
  },
  '& *': {
    opacity: 1,
    transition: 'opacity 0.3s ease-in-out',
  },
}));

export const InsuranceInfoIconButton = styled(IconButton)({
  padding: '0',
  marginRight: '17px',
  color: '#414046',
});

export const InsuranceInfoTypography = styled(Typography)({
  fontFamily: 'Poppins',
  fontWeight: 400,
  fontSize: '12px',
  lineHeight: '15.6px',
  letterSpacing: '0.15px',
  color: '#414046',
  span: {
    fontWeight: 500,
  },
});
